module.exports = {"430822100":"澧源镇","430822101":"瑞塔铺镇","430822102":"官地坪镇","430822103":"凉水口镇","430822104":"龙潭坪镇","430822105":"五道水镇","430822106":"陈家河镇","430822107":"廖家村镇","430822108":"利福塔镇","430822109":"八大公山镇","430822110":"桥自弯镇","430822111":"人潮溪镇","430822200":"空壳树乡","430822202":"竹叶坪乡","430822203":"走马坪白族乡","430822207":"刘家坪白族乡","430822208":"芙蓉桥白族乡","430822210":"马合口白族乡","430822213":"洪家关白族乡","430822216":"沙塔坪乡","430822224":"河口乡","430822225":"上河溪乡","430822228":"上洞街乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430822.json
// module id = 2008
// module chunks = 0